import React from "react";

export const Services = ({ data }) => {
  return (
    <section
      id="services"
      style={{
        background: "linear-gradient(to right, #025e20 0%, #7dad8d 100%)",
        color: "rgba(255, 255, 255, 0.85)",
        padding: "60px 0",
      }}
    >
      <div className="container text-center">
        {/* Section Header */}
        <div className="section-title mb-5" style={{ maxWidth: 900, margin: "0 auto" }}>
          <h2 style={{ fontWeight: 800, fontSize: 40, marginBottom: 20 }}>
            FARMER ENGAGEMENT
          </h2>
          <p style={{ fontSize: 18, lineHeight: 1.7 }}>
            Stawi sources high quality raw material from over{" "}
            <strong>6,300 smallholder farmers</strong> in rural Kenya.  
            We are working with partners to solve these problems affecting Kenya’s young farmers:
          </p>
        </div>

        {/* Dynamic Problems */}
        <div className="row" style={{ textAlign: "left", maxWidth: 1000, margin: "0 auto" }}>
          {data ? (
            data.map((item, i) => (
              <div key={i} className="col-md-12 mb-4">
                <div
                  style={{
                    background: "rgba(255,255,255,0.1)",
                    padding: "24px 28px",
                    borderRadius: 12,
                    boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "flex-start" }}>
                    {/* Main Number */}
                    <span
                      style={{
                        fontWeight: "bold",
                        fontSize: 22,
                        marginRight: 16,
                        minWidth: 28,
                      }}
                    >
                      {i + 1}.
                    </span>

                    {/* Content */}
                    <div>
                      <h3 style={{ fontWeight: 700, fontSize: 22, marginBottom: 12 }}>
                        {item.title}
                      </h3>
                      <p style={{ fontSize: 16, marginBottom: 12 }}>{item.text}</p>

                      {/* Subpoints */}
                      {item.points && (
                        <ul style={{ listStyle: "none", paddingLeft: 0 }}>
                          {item.points.map((point, j) => {
                            // Handle Roman numerals if specified
                            const romanNums = ["i", "ii", "iii", "iv", "v", "vi"];
                            const label =
                              item.type === "roman"
                                ? `${romanNums[j]})`
                                : "✅";

                            return (
                              <li
                                key={j}
                                style={{
                                  marginBottom: 10,
                                  fontSize: 16,
                                  display: "flex",
                                  alignItems: "flex-start",
                                }}
                              >
                                <span
                                  style={{
                                    marginRight: 8,
                                    fontWeight: item.type === "roman" ? "bold" : "normal",
                                  }}
                                >
                                  {label}
                                </span>
                                <span>{point}</span>
                              </li>
                            );
                          })}
                        </ul>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p>Loading...</p>
          )}
        </div>
      </div>
    </section>
  );
};
